export default "__VITE_ASSET__efcb10ed__"